export function getValueByDotNotation(obj, key) {
  const keys = key.split(".");
  let current = obj;
  for (let i = 0; i < keys.length; i++) {
    const keyPart = keys[i];
    if (!current || !current.hasOwnProperty(keyPart)) {
      return undefined;
    }
    current = current[keyPart];
  }
  return current;
}
getValueByDotNotation(window.translations, "general.header.newBadge");
export function translation(key) {
  return getValueByDotNotation(window.translations, key);   
}

export function hidePhpBlock() {
  document.querySelectorAll(".php-block").forEach((element) => {
    element.style.display = "none";
  });
}